// @flow
import client, { deleteJWTToken, getRefreshToken } from '../../client'
import type { TokenBlacklist } from '../../api_types'

export const TOKEN_BLACKLIST_ENDPOINT = '/auth/token-blacklist/'

/**
 * Logout an user
 * @return {Promise<TokenBlacklist>} A resolved Promise with the server response or rejected with an Error
 */
export const logout = async (): Promise<TokenBlacklist | null> => {
  const refreshToken = getRefreshToken()

  if (!refreshToken) {
    throw new Error('No refresh token found')
  }

  try {
    const response: TokenBlacklist = await client.post(
      TOKEN_BLACKLIST_ENDPOINT,
      {
        body: { refresh_token: refreshToken },
      }
    )
    deleteJWTToken()

    return response
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to logout:', error)
    throw error
  }
}

export default logout
